import CustomFilterSelect from "./CustomFilterSelect";
const FilterLoanShortStatus = (props: any) => {
  return (
    <CustomFilterSelect
      source="curStatus"
      label="Status"
      choices={[
        { id: "Active", name: "Active" },
        { id: "Charged-Off", name: "Charged-Off" },
        { id: "Paid-Off", name: "Paid-Off" },
        { id: "Voided", name: "Voided" },
      ]}
      before={props?.before != null && props.before !== "" ? props.before : ""}
    />
  );
};

export default FilterLoanShortStatus;
